<div 
  class="building-popup"
  [style.left.px]="screenX"
  [style.top.px]="screenY"
>
  <!-- HEADER -->
  <div class="popup-header">
    <div class="title-section">
       @if (data?.buildingEntity?.type === 'CampusMapEntity') {
      <div class="building-icon">
        <img src="assets/img/icons/campus.png" />
      </div>
      } 
      @if (data?.buildingEntity?.type !== 'CampusMapEntity') {
      <div class="building-icon">
        <img src="assets/img/icons/buildings.png" />
      </div>
      }
      <div>
        <div class="title">{{ data?.name }}</div>
        <div class="subtitle">{{ data?.address }}</div>
      </div>
    </div>

    <div class="close-btn" (click)="closePopup()">✕</div>
  </div>

  <!-- STATS -->
  @if (data?.buildingEntity?.type !== 'CampusMapEntity') {
    <div class="popup-stats">
      <div class="stat-item">
        <img src="assets/img/icons/Vector.png" title="Height" />
        <span>{{ data?.height || 0 }} m</span>
      </div>

      <div class="stat-item">
        <img src="assets/img/icons/Frame.png" title="Floors" />
        <span>{{ data?.floors || 0 }}</span>
      </div>

      <div class="stat-item">
        <img src="assets/img/icons/bluetooth.png" title="Beacons" />
        <span>{{ data?.beacons || 0 }}</span>
      </div>
    </div>
  }
  <!-- PEOPLE -->
  <div class="popup-stats">
    <div class="people-item danger">
      <img src="assets/img/arcangel/user_in_danger.svg" title="Danger" />
      {{ data?.people?.[0]?.count || 0 }}
    </div>

    <div class="people-item safe">
      <img src="assets/img/arcangel/user_safe.svg" title="Safe" />
      {{ data?.people?.[1]?.count || 0 }}
    </div>

    <div class="people-item unknown">
      <img src="assets/img/arcangel/user_unknown.svg" title="Unknown" />
      {{ data?.people?.[2]?.count || 0 }}
    </div>

    <div class="people-item other d-none">
      <img src="assets/img/arcangel/user_suspect.svg" title="Suspect" />
      {{ data?.people?.[3]?.count || 0 }}
    </div>
  </div>

  <!-- ALERTS   *ngIf="data?.alerts > 0"-->
  <div class="popup-alerts">
    <img src="assets\img\arcangel\alert-icon.png" /> 
    Active alerts {{ data?.alerts || 0}}
  </div>
</div>